import {request} from '../utils/request';

/**
 * 获取角色分页列表
 * @param {Object} data - 查询参数
 * @param {number} data.PageIndex - 页码
 * @param {number} data.PageSize - 每页数量
 * @param {number} data.TenantId - 租户ID（可选）
 * @param {string} data.RoleName - 角色名称（可选）
 * @param {number} data.RoleType - 角色类型（可选）
 * @param {number} data.IsSystem - 是否系统角色（可选）
 * @param {number} data.IsEnabled - 是否启用（可选）
 */
export const getRolePageList = (data) => {
  return request({
    url: '/Role/GetPageList',
    method: 'post',
    data,
  });
};

/**
 * 获取角色详情
 * @param {number} id - 角色ID
 */
export const getRoleDetail = (id) => {
  return request({
    url: '/Role/GetDetail',
    method: 'get',
    params: { id },
  });
};

/**
 * 添加角色
 * @param {Object} data - 角色数据
 */
export const addRole = (data) => {
  return request({
    url: '/Role/Add',
    method: 'post',
    data,
  });
};

/**
 * 更新角色
 * @param {Object} data - 角色数据
 */
export const updateRole = (data) => {
  return request({
    url: '/Role/Update',
    method: 'post',
    data,
  });
};

/**
 * 更新角色状态
 * @param {Object} data - 状态数据
 * @param {number} data.IsEnabled - 是否启用 (0/1)
 * @param {Array<number>} data.Ids - 角色ID数组
 */
export const updateRoleStatus = (data) => {
  return request({
    url: '/Role/UpdateStatus',
    method: 'post',
    data,
  });
};

/**
 * 删除角色
 * @param {Object} data - 删除数据
 * @param {Array<number>} data.Ids - 角色ID数组
 */
export const deleteRole = (data) => {
  return request({
    url: '/Role/Delete',
    method: 'post',
    data,
  });
};
